import { Component, Input, Output, EventEmitter } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'app-lrtdrtavailablity',
    templateUrl: './lrtdrtavailablity.component.html',
    styleUrls: ['./lrtdrtavailablity.component.scss']
})
export class LrtdrtavailablityComponent {
    @Input() teacherData: any;
    @Input() visible = false;
    @Output() closed = new EventEmitter<void>();
    @Input() bookingDetails: any;
    calendarDates: { date: string; day: string; status: string; note?: string }[] = [];
    availabilityLrtDrt: any;
    // bookingPeriod: any;
    contractAvailability: any;
    totalBookingHours: string = '';

    close() {
        this.closed.emit();
    }

    ngOnInit() {
        this.contractAvailability = this.teacherData?.contract_availbility;
        this.availabilityLrtDrt = this.teacherData?.contract_availbility?.availability;
        // Create a comma separated string of "date day" values from the availability array
        // if (Array.isArray(this.teacherData?.contract_availbility?.availability)) {
        //     const dateDayArr = this.teacherData.contract_availbility.availability.map(
        //         (item: any) => `${item.date} ${item.day}`
        //     );
        //     this.bookingPeriod = dateDayArr.join(', ');
        // } else {
        //     this.bookingPeriod = '';
        // }
        console.log('LRT/DRT Availability:', this.availabilityLrtDrt);
        console.log('Teacher Data:', this.teacherData);


        const start = moment(this.bookingDetails?.start_time, 'HH:mm');

        const end = moment(this.bookingDetails?.end_time, 'HH:mm');

        let duration = moment.duration(end.diff(start));
        if (duration.asMinutes() < 0) duration = moment.duration(0, 'minutes');

        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();

        let bookingHoursText = '';
        if (hours > 0) bookingHoursText += `${hours} hour${hours > 1 ? 's' : ''}`;
        if (minutes > 0) bookingHoursText += (bookingHoursText ? ' ' : '') + `${minutes} minute${minutes > 1 ? 's' : ''}`;
        this.totalBookingHours = bookingHoursText;
    }


    getStatusLabel(status: string, day: any): string {
        // console.log('Getting status label for:', status);
        switch (status) {
            case 'haventindicated': return 'HI'; // Haven’t Indicated
            case 'booked': return 'B';   // Booked
            case 'unavailable': return 'UA'; // Unavailable
            case 'available': return 'A';   // Available
            case 'booked_externally': return 'BE'; // Booked Elsewhere
            case 'lrt_contract': return 'L'; // LRT Contract
            case 'drt_contract': return 'D'; // DRT Contract
            default: return '';
        }
    }

    getStatusClass(status: string): string {
        // console.log('Getting status class for:', status);
        switch (status) {
            case 'haventindicated': return 'status-hi';
            case 'booked': return 'status-b';
            case 'unavailable': return 'status-ua';
            case 'available': return 'status-a';
            case 'booked_externally': return 'status-be';
            case 'lrt_contract': return 'status-lrt';
            case 'drt_contract': return 'status-drt';
            default: return '';
        }
    }


}
